import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { ContainerDocumentosSindico } from './styles';
import FoldersContainer from '../../../../Components/FoldersContainer';

import Dropdown from '../../../../Components/Dropdown';
import { ContextSindico } from '../../../../services/sindico';
import { PageTitle } from '../../styles';
import loadSindico from '../../loadSindico';
import EmptyState from '../../../../Components/EmptyState';
import NoFilesIcon from '../../../../assets/novosicones/Sindico/NoFiles.svg';
import { useHistory } from 'react-router-dom';
export default function LayoutDocumentosSindico() {
  const {
    listDocuments,
    tema,
    loadImoveisDisponiveis,
    listaDeImoveis,
    getFolders,
    folders,
    logoutSindico,
    verifyIfUrlIsValid,
  } = useContext(ContextSindico);

  const [selectedPaths, setSelectedPaths] = useState([]);
  const [documentsList, setDocumentsList] = useState({});

  const [selectedBuilding, setSelectedBuilding] = useState({});

  const [isLoadingBuildings, setIsLoadingBuildings] = useState(true);

  const currentPath = useMemo(() => {
    return selectedPaths.slice(-1)[0];
  }, [selectedPaths]);

  const history = useHistory();

  const loadMoreFiles = useCallback(async () => {
    const params = {
      IdEmpreendimento: selectedBuilding?.id,
      IdPasta: currentPath?.idExterno,
      pagina: documentsList && documentsList[currentPath?.nome]['pagina'] + 1,
    };

    const documentsFounded = await listDocuments(params);

    if (documentsFounded?.filesFounded && documentsList) {
      const { filesFounded, pagina, qtdDePaginas, itensQtdTotal } =
        documentsFounded;
      const filesUpdated = Object.assign(documentsList, {
        [currentPath.nome]: {
          pagina,
          qtdDePaginas,
          filesFounded: [
            ...documentsList[currentPath.nome]['filesFounded'],
            ...filesFounded,
          ],
          itensQtdTotal,
        },
      });
      setDocumentsList({ ...documentsList, ...filesUpdated });
    }
  }, [documentsList, currentPath, listDocuments, selectedBuilding.id]);

  const loadFolderFiles = useCallback(async () => {
    const params = {
      IdEmpreendimento: selectedBuilding.id,
      IdPasta: currentPath.idExterno,
    };

    const documentsFounded = await listDocuments(params);

    if (documentsList) {
      const filesUpdated = Object.assign(documentsList, {
        [currentPath.nome]: {
          filesFounded: [],
          pagina: 1,
          qtdDePaginas: 1,
          ...documentsFounded,
        },
      });
      setDocumentsList({ ...filesUpdated });
    }
  }, [documentsList, currentPath, listDocuments, selectedBuilding.id]);

  const onSelectBuilding = useCallback((building) => {
    console.log('building', building);
    console.log('listaDeImoveis', listaDeImoveis);

    setSelectedBuilding(building);

    setSelectedPaths([{ nome: building?.nome }]);
  }, []);

  const onOpenFile = useCallback(
    async (file) => {
      const newUrl = await verifyIfUrlIsValid(file.urlAws, file.idAWS);

      if (newUrl) {
        file.urlAws = newUrl;

        setDocumentsList({ ...documentsList });
        return newUrl;
      }

      return file.urlAws;
    },
    [currentPath, documentsList]
  );

  const showEmptyState = useMemo(() => {
    return !selectedBuilding?.temDocumentos;
  }, [selectedBuilding]);

  useEffect(() => {
    if (!loadSindico()) {
      logoutSindico();
      return;
    }

    if (loadSindico()?.redirectToGuiare) {
      history.push('/sindico/inicio');
      return;
    }

    async function handleInitialRequest() {
      await Promise.all([await loadImoveisDisponiveis(), await getFolders()]);
      setIsLoadingBuildings(false);
    }

    handleInitialRequest();
  }, []);
  return (
    <ContainerDocumentosSindico>
      <div>
        <PageTitle tema={tema}>Documentos do Imóvel</PageTitle>
        {selectedPaths?.length < 2 && (
          <Dropdown
            placeholderSearchBar='Buscar empreendimento'
            textNotSelected='Selecione um empreendimento'
            setSelectedItem={setSelectedBuilding}
            onSelectItem={onSelectBuilding}
            selectedItem={selectedBuilding}
            itensList={listaDeImoveis}
            isLoading={isLoadingBuildings}
            textEmpty='Nenhum empreendimento encontrado.'
            marginTop={24}
            width={500}
          />
        )}

        {selectedBuilding?.id && !showEmptyState && (
          <FoldersContainer
            documentsList={documentsList && documentsList[currentPath.nome]}
            documentsFolders={folders}
            currentPath={currentPath.nome}
            selectedPaths={selectedPaths}
            setSelectedPaths={setSelectedPaths}
            loadMoreFiles={loadMoreFiles}
            loadFolderFiles={loadFolderFiles}
            onOpenFile={onOpenFile}
          />
        )}
      </div>
      {showEmptyState && (
        <EmptyState
          icon={NoFilesIcon}
          title='Não há arquivos para este empreendimento'
          // subtitle='Adicione arquivos clicando no botão “Novo”'
        />
      )}
    </ContainerDocumentosSindico>
  );
}
